__webpack_require__.p = "https://static.cdn-ezcater.com/delivery-management-react/";